import TemplateNone from '../components/ui/TemplateNone/TemplateNone';
import TemplateSelected from '../components/ui/TemplateSelected/TemplateSelected';
import TemplatesFormChange from '../components/ui/TemplatesFormChange/TemplatesFormChange';
import { modeList } from './modeList';

export const templatesMode = {
  [modeList.NOTHING_MODE]: TemplateNone,
  [modeList.SELECTED_MODE]: TemplateSelected,
  [modeList.CHENGE_MODE]: TemplatesFormChange,
  [modeList.ADD_TEMPLATE_MODE]: TemplatesFormChange,
};
